import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {NewsComponent} from './components/news/news.component';
import {SharedModule} from './shared.module';
import {LazyLoadImageModule} from 'ng-lazyload-image';

@NgModule({
  declarations: [
    NewsComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    LazyLoadImageModule,
  ],
  bootstrap: [NewsComponent]
})
export class NewsModule {
  static components = {
    news: NewsComponent,
  };
}
